import {create} from 'zustand';

const useDeviceChanged = create((set) => {
  return {
    isChanged: false,
    setChanged: (newState) => set({ isChanged: newState }),
    // resetChanged: () => set((state) => ({isChanged: false})),
    // setChanged: () => set((state) => ({isChanged: true})),
  };
});

export default useDeviceChanged;